function About() {
  return (
    <div className="container">
      <div className="card">
        <h2>About Me 👩‍💻</h2>
        <p>
          I am Deepthi, a BE student passionate about web development and building
          projects using React.
        </p>
      </div>
    </div>
  );
}

export default About;